import { FC } from 'react'
import { useTranslation } from "react-i18next"
import { RotationRightButton } from '../../../../components/buttons/iconButtons/action/RotationCollection'
import { HighLightButton } from '../../../../components/buttons/iconButtons/editor/ActionCollection'
import BaseCommandsPanel, { ShowDeletedCheckbox } from '../../../../components/commandsPanels/BaseCommandsPanel'
import Tooltip from '../../../../components/tooltips/Tooltip'
import GridWrapper from '../../../../components/controls/GridWrapper'
import { checkActiveCommands } from '../../../CommonHelperFunctions'
import { useUserContext } from '../../../../system/providers/userContextProvider'
import { FilePlusButton } from '../../../../components/buttons/iconButtons/other/FileAndFolderCollection'
import { Delete2Button, DeleteButton, SearchButtonPanel } from '../../../../components/buttons/iconButtons/action/MainCollection'
import { Button } from '../../../../components/buttons/button'

interface IPanelEvent {
    disabled?: boolean;
    onClick: () => any;
    onSubItemClick?: () => any;
    value?: any;
}

interface INewsMakerPanelProps {
    add?: IPanelEvent;
    edit?: IPanelEvent;
    delete?: IPanelEvent;
    restore?: IPanelEvent;
    refresh?: IPanelEvent;
    test?: IPanelEvent;
    search?: IPanelEvent;
    assignToAll?: IPanelEvent;
    assignToUser?: IPanelEvent;
    permission?: IPermission;
    hasActiveFilters: boolean;
    showDeleted?: boolean;
}

export const NewsMakerPanel: FC<INewsMakerPanelProps> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t('documentsCommandsPanel.' + value)
    const userContext = useUserContext();
    // const activeCommands = checkActiveCommands(props.permission as IPermission, userContext.userPermission);
    const activeCommands = {
        add: true,
        edit: true,
        refresh: true,
        delete: true,
        restore: true,
        search: true,
        assignToAll: true,
        assignToUser: true,
    }

    return (
        <>
            <GridWrapper cols={5}>
                <BaseCommandsPanel groups={[
                    [
                        {
                            iconButton: <Tooltip title={baseT('addNote')}>
                                <FilePlusButton sizeVariant="mini" {...{ ...props.add, disabled: props.add?.disabled || !activeCommands.add }} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title={baseT('editNote')}>
                                <HighLightButton sizeVariant="mini" {...{ ...props.edit, disabled: props.edit?.disabled || !activeCommands.edit }} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title={baseT('refresh')}>
                                <RotationRightButton sizeVariant="mini" {...{ ...props.refresh, disabled: props.refresh?.disabled || !activeCommands.refresh }} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title="Поиск">
                                <div style={props.hasActiveFilters ? { backgroundColor: 'rgb(153, 204, 255)', borderRadius: "2px" } : {}}>
                                    <SearchButtonPanel sizeVariant="mini" {...{ ...props.search, disabled: props.search?.disabled || !activeCommands.search }} />
                                </div>
                            </Tooltip>
                        },
                    ],
                    [
                         {
                            iconButton: <Tooltip title={baseT('deleteNote')}>
                                <Delete2Button sizeVariant="mini" colorVariant='danger' {...{ ...props.delete, disabled: props.delete?.disabled || !activeCommands.delete }} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title={baseT('recoverNote')}>
                                <DeleteButton sizeVariant="mini" colorVariant="success" {...{ ...props.restore, disabled: props.restore?.disabled || !activeCommands.restore }} />
                            </Tooltip>
                        }
                    ],
                    [
                        {
                            iconButton: <Tooltip title={baseT('assignToAll')}>
                                {/* <DeleteButton sizeVariant="mini" colorVariant="success" {...{ ...props.restore, disabled: props.restore?.disabled || !activeCommands.restore }} /> */}
                               <Button style={{width: 150}} variant="commandPanel" {...{...props.assignToAll, disabled: props.assignToAll?.disabled || !activeCommands.assignToAll}}>{baseT('assignToAll')}</Button>
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title={baseT('assignToUser')}>
                                {/* <DeleteButton sizeVariant="mini" colorVariant="success" {...{ ...props.restore, disabled: props.restore?.disabled || !activeCommands.restore }} /> */}
                               <Button style={{width: 200}} variant="commandPanel" {...{...props.assignToUser, disabled: props.assignToUser?.disabled || !activeCommands.assignToUser}}>{baseT('assignToUser')}</Button>
                            </Tooltip>
                        }

                    ]
                    
                ]}
                />
              
            </GridWrapper>
        </>
    )
}
